<div class="d-flex flex-wrap gap-3"
     [ngClass]="{ 'flex-column': !horizontal }">
    @for (calendarProvider of calendarProviders; track calendarProvider) {
        <div class="me-auto">
            <adapt-render-component [component]="calendarProvider.connectComponent"
                                    [componentInputs]="{ showLogoutButton, disabled }"></adapt-render-component>
        </div>
    }
    @if (errorMessage) {
        <div class="alert alert-danger w-100 mb-0"
             role="alert">
            {{ errorMessage }}
        </div>
    }

    @if (!hasConfigureAccess && (!calendarProviders || calendarProviders.length === 0 || !provider)) {
        <div class="alert alert-warning"
             role="alert">Calendar integration has not been configured for this organisation, please contact your {{ projectLabel }}
            administrator to enable integration.</div>
    }
</div>
